import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { VisitService } from '../rest_services/visit.service';
import { VisitsService } from '../rest_services/visits.service';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

@Component({
  selector: 'app-cover-page',
  templateUrl: './cover-page.component.html',
  styleUrls: ['./cover-page.component.css']
})
export class CoverPageComponent implements OnInit {

  visitStatisticsSubscription!: Subscription;
  constructor(private visitsService:VisitsService, private visitService:VisitService) { }
  currentYear:number=0;
  loadingCover:boolean=true;
  connectedCompany:any="";

  ngOnInit(): void {
    if(localStorage.getItem("comp")!=undefined){
      this.connectedCompany = localStorage.getItem("comp")?.toString();
    }else {
      this.connectedCompany = sessionStorage.getItem("comp")?.toString();
    }
    this.currentYear = new Date().getFullYear();
    this.getCommercials();
    setTimeout(()=>{
      (<any>$('#example')).DataTable( {
        "destroy":true,
        "ordering": false,
        "processing": true,
        "pagingType": "full_numbers",
        // "scrollX": '400px',
        searching: false, paging: false,
        "scrollCollapse": true,
        "language": {
          "sProcessing": "Traitement en cours ...",
          "sLengthMenu": "Afficher _MENU_ lignes",
          "sZeroRecords": "Aucun résultat trouvé",
          "sEmptyTable": "Aucune donnée disponible",
          "sInfo": "",
          "sInfoEmpty": "",
          searchPlaceholder: "Saisir un mot clé",
          "sInfoFiltered": "",
          "sInfoPostFix": "",
          "sSearch": "Rechercher:",
          "sUrl": "",
          "sInfoThousands": ",",
          "sLoadingRecords": "Chargement...",
          "oPaginate": {
            "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
          },
          "oAria": {
            "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
          }
        }
      } );
      $('.dataTables_empty').html('<div _ngcontent-lpv-c73="" class="col-xl-12 col-md-12 col-sm-12 col-12" style="position: absolute;"><ul _ngcontent-lpv-c73="" class="list-inline mb-3 d-flex justify-content-sm-end justify-content-center mr-sm-3 ml-sm-0 mx-3"><li _ngcontent-lpv-c73="" class="list-inline-item align-self-center"><div _ngcontent-lpv-c73="" class="scrollTop"><i _ngcontent-lpv-c73="" class="flaticon-up-arrow-fill-1"></i></div></li></ul></div>');

    }, 200);
  }
  commercials:any[]=[];
  getCommercials(){
    this.visitService.getCommercialsToAffect();
    this.visitService.commercialsSubject.subscribe(
      ( data: any ) => {
        if(data.code=="b1f37eec383fcada527079602ac178b3"){   
          this.commercials = data.commercials
        .filter((commercial: any) => commercial.profile !== "981dc265-63b8-45ba-b356-befb5a9a6f74");
          for(var commercial of data.commercials){
            var statsCommercial:any = {id:null,commercial:null,stats:null};
            statsCommercial.commercial =commercial.commercial;
            statsCommercial.id = commercial.commercial_uuid;
            this.getVisitCoverOfCommercial(statsCommercial,commercial, this.commercials.indexOf(commercial));
            $("#nodata-"+data.commercials.indexOf(commercial)).hide();
          }
          this.loadingCover =false;
        }
      },
    )  
  }
  loadingVisitsCover:boolean=false;
  cover:any[any]=[];
  getVisitCoverOfCommercial(commercial:any,objCommercial:any,index:any){
    var totalVisitsGoal = 0;
    var totalVisitsMade = 0;
    this.visitStatisticsSubscription = this.visitsService.getVisitsStatisticsCover(commercial.id).subscribe(
      (res: any) => {
        if(res.code == "SUCCESS"){
          var statsCommercial:any = {id:commercial.id,commercial:commercial.commercial,stats:[]};
          for (const iterator of res.cover.coverMonth) {            
            iterator.month = this.getMonthName(iterator.month);
            totalVisitsGoal= totalVisitsGoal +iterator.classACover?.visitsGoal + iterator.classBCover?.visitsGoal + iterator.classCCover?.visitsGoal;
            totalVisitsMade= totalVisitsMade +iterator.classACover?.visitsMade + iterator.classBCover?.visitsMade + iterator.classCCover?.visitsMade;
            if(iterator.classDCover!=null && iterator.classDCover!=undefined){
              totalVisitsGoal= totalVisitsGoal +iterator.classDCover?.visitsGoal;
              totalVisitsMade= totalVisitsMade +iterator.classDCover?.visitsMade;
            }
          }
          statsCommercial.stats =res.cover.coverMonth
          this.cover.push(statsCommercial);
          this.initChart(index,objCommercial,totalVisitsGoal,totalVisitsMade);
        }
      },
      (err: any) => {
        console.log(err);
        this.loadingVisitsCover = false;
      });
    };
  getMonthName(monthNumber:number) {
    const date = new Date();
    date.setMonth(monthNumber - 1);
    var month = date.toLocaleString('fr-FR', {
      month: 'long',
    });
    month = month.charAt(0).toUpperCase() + month.slice(1);
    return month;
  }

  // COVER PROGRESSION CHARTS
  initChart(index:any,commercial:any,maxVisits:number,currentNumber:number){
    $("#loading-"+index).hide();
    if(maxVisits==0 && currentNumber==0){
      $("#nodata-"+index).show();
      $("#chartdiv"+index).hide();
    }else {
      $("#nodata-"+index).hide();
      var chart:any = null;
      if (chart != null) {
        chart.dispose();
        chart = null;
      }
      commercial.goal = maxVisits ;
      commercial.made = currentNumber;
      if(currentNumber>=maxVisits/3){
        $("#background-card-"+index).removeClass('fa fa-ellipsis-h');
        $("#imageContent-"+index).addClass("meta-medium")
        $("#background-card-"+index).addClass("fa fa-hand-lizard big-centered-icon-soso");
      }else if(currentNumber<maxVisits/3){
        $("#background-card-"+index).removeClass('fa fa-ellipsis-h');
        $("#imageContent-"+index).addClass("meta-bad")
        $("#background-card-"+index).addClass("flaticon-like-3 fa-flip-vertical big-centered-icon-bad");
      }else {
        $("#background-card-"+index).removeClass('fa fa-ellipsis-h');
        $("#imageContent-"+index).addClass("meta-good")
        $("#background-card-"+index).addClass("flaticon-like-3 big-centered-icon-good");
      }
      
      am4core.useTheme(am4themes_animated);
      // create chart
      chart = am4core.create("chartdiv"+index, am4charts.GaugeChart);
      chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect

      chart.innerRadius = -25;

      let axis = chart.xAxes.push(new am4charts.ValueAxis<am4charts.AxisRendererCircular>());
      axis.min = 0;
      axis.max = maxVisits;
      axis.strictMinMax = true;
      axis.renderer.grid.template.stroke = new am4core.InterfaceColorSet().getFor("background");
      axis.renderer.grid.template.strokeOpacity = 0.3;

      let colorSet = new am4core.ColorSet();

      let range0:any = axis.axisRanges.create();
      range0.value = 0;
      range0.endValue = maxVisits/3;
      range0.axisFill.fillOpacity = 1;
      range0.axisFill.fill = colorSet.getIndex(0);
      range0.axisFill.zIndex = - 1;

      let range1:any = axis.axisRanges.create();
      range1.value = maxVisits/3;
      range1.endValue = maxVisits/3 + maxVisits/3;
      range1.axisFill.fillOpacity = 1;
      range1.axisFill.fill = colorSet.getIndex(2);
      range1.axisFill.zIndex = -1;

      let range2:any = axis.axisRanges.create();
      range2.value = maxVisits/3 + maxVisits/3;
      range2.endValue = maxVisits;
      range2.axisFill.fillOpacity = 1;
      range2.axisFill.fill = colorSet.getIndex(4);
      range2.axisFill.zIndex = -1;
      let hand = chart.hands.push(new am4charts.ClockHand());
      // using chart.setTimeout method as the timeout will be disposed together with a chart
      chart.setTimeout(randomValue, 1000);
      function randomValue() {
          var rand = Math.random() * 100;
          hand.showValue(currentNumber, 1000, am4core.ease.cubicOut);
          $("#btn-details"+index).show();
          setTimeout(()=>{
            var legends = Array.from(document.querySelectorAll('g[stroke-width="1.7999999999999998"]'));
            
            legends.forEach((legend) => {
              legend?.setAttribute("style","display:none !important;")
            });
          }, 300);
      }
    }
  }

  coverDetail:any[]=[];
  totalGoalYear:number=0;
  totalMadYear:number=0;
  getDetailsCoverCommercial(commercial:string,goal:number,made:number){
    this.totalGoalYear =goal;
    this.totalMadYear =made;
    $('html, body').animate({
      scrollTop: $("#bloc-detail-cover")?.offset()?.top
    }, 2000);
    $("#bloc-detail-cover").addClass("visible")
    this.coverDetail = this.cover.filter((d: any) => d.commercial === commercial);
  }
}
